export default __webpack_public_path__ + "static/media/service.93a5ce91.png";